package com.essntl.features.dashboard.ui

sealed interface DashboardNavigation {
    data class EditItineraryServices(val itineraryId: String) : DashboardNavigation
    data class EditProposal(val proposalId: String) : DashboardNavigation
    data class EditRequest(val requestId: String) : DashboardNavigation
    data class EditTask(val taskId: String) : DashboardNavigation
}